import React, { FC, useMemo } from 'react'
import { Gateway } from 'src/api'
import { ProjectList } from '../project/projectList'
import ProjectColumns from '../../columns/project'

interface GatewayCurrentProjectsProps {
  gateway: Gateway
  noResultText?: string
  showFooter?: boolean
}

const projectColumns = [ProjectColumns.Name, ProjectColumns.Location, ProjectColumns.ContractorName]

export const GatewayCurrentProjects: FC<GatewayCurrentProjectsProps> = ({ gateway, noResultText, showFooter = false }) => {
  const projects = useMemo(() => {
    if (!gateway.gatewayProjects) return []
    return gateway.gatewayProjects
      .filter((gp) => gp.isActive && gp.project)
      .sort((a, b) => (a.project?.name || '').localeCompare(b.project?.name || ''))
      .map((gp) => gp.project!)
  }, [gateway.gatewayProjects])

  return <ProjectList data={projects} count={projects.length} noResultText={noResultText} showFooter={showFooter} columns={projectColumns} />
}
